import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../Reducers/RootReducer';

const easyFitStore = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default easyFitStore;
